import { MessageCircle } from "lucide-react";
import { buildWhatsAppUrl, trackEvent } from "@/lib/utm";

export default function FloatingWhatsApp() {
  const wa = buildWhatsAppUrl(
    "5218116289267",
    "Hola Eclipse, me interesa cotizar FlexShade. Vi su landing."
  );
  return (
    <a
      href={wa}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      onClick={() => trackEvent("whatsapp_click", { location: "floating_button" })}
      className="wa-pulse fixed bottom-6 right-6 z-50 btn-wa px-4 md:px-5 py-3 md:py-3.5 rounded-full shadow-2xl inline-flex items-center gap-2 text-sm md:text-base"
      aria-label="Cotiza gratis por WhatsApp"
    >
      <MessageCircle className="w-5 h-5 md:w-6 md:h-6" />
      <span className="hidden sm:inline">Cotiza gratis</span>
    </a>
  );
}
